<template lang="pug">
  div.site_container
    Header
    main.main_container
      router-view
    Copyright
</template>

<script>
import Header from '@/components/PublicHeader.vue'
import Copyright from '@/components/PublicCopyright.vue'

export default {
  name: 'public',
  components: {
    Header,
    Copyright
  }
}
</script>

<style lang="sass" scoped>
$font-jp_primary: 'Noto Sans JP','Hiragino Kaku Gothic ProN', 'ヒラギノ角ゴ ProN W3', 'メイリオ', 'Meiryo', 'verdana', sans-serif
.site_container
  font-family: $font-jp_primary
  /* buefy打ち消し */
  -webkit-font-smoothing: auto
</style>
